// extracted by mini-css-extract-plugin
export default {"header":"Table_header__KbHsv","link":"Table_link__9tMq0"};